import React from "react";
import DotedPart from "../common/DotedPart";
import BlogsMain from "./BlogsMain";

const IndexBlogs = () => {
  return (
    <>
      <BlogsMain />
      <DotedPart className="my-[50px] md:my-[89px]" />
    </>
  );
};

export default IndexBlogs;
